export enum PermissionType {
  AdminTeamSection = 'admin_team_section',
  AdminTeamEditUser = 'admin_team_edit_user',
  AdminTeamNewUser = 'admin_team_new_user',
  AdminTeamUserList = 'admin_team_user_list',
  AdminNotesHistory = 'AdminNotesHistory',

  MapSection = 'map_section',
  MapSectionVehicle = 'map_section_vehicle',
  MapSectionDrivers = 'map_section_drivers',
  MapSectionGeofences = 'map_section_geofences',
  MapView = 'map_view',

  ClientSection = 'client_section',
  ClientEdit = 'client_edit',
  ClientEditUser = 'client_edit_user',
  ClientNewUser = 'client_new_user',
  ClientUserList = 'client_users_list',
  ClientView = 'client_view',
  ClientDeleteUser = 'client_delete_user',
  ClientList = 'client_list',
  ClientNotesHistory = 'client_notes_history',

  DriverList = 'driver_list',
  DriversSection = 'drivers_section',
  DriversEditAccessInfo = 'drivers_edit_access_info',
  DriversEditProfileInfo = 'drivers_edit_profile_info',
  DriversAddDriver = 'drivers_add_driver',

  AssetSection = 'asset_section',
  AssetNew = 'asset_new',
  AssetEdit = 'asset_edit',
  AssetDelete = 'asset_delete',
  AssetList = 'asset_list',
  AssetInstallUninstall = 'asset_install_uninstall',
  AssetServiceReminders = 'asset_service_reminders',
  AssetВocuments = 'asset_documents',
  AssetSectionServiceReminders = 'asset_section_service_reminders',
  AssetSectionDocuments = 'asset_section_documents',
  AssetSectionEditServiceReminder = 'asset_section_edit_service_reminder',
  AssetSectionEditDocuments = 'asset_section_edit_documents',
  AssetSectionEditRepairCosts = 'asset_section_edit_repair_costs',

  DrivingBehaviourSection = 'driving_behaviour_section',
  DrivingBehaviourDashboard = 'driving_behaviour_dashboard',
  DrivingBehaviourVehicles = 'driving_behaviour_vehicles',
  DrivingBehaviourDrivers = 'driving_behaviour_drivers',

  NewClient = 'new_client',

  DevicesSection = 'devices_section',
  DeviceList = 'device_list',
  DeviceNew = 'device_new',
  DeviceEdit = 'device_edit',
  DeviceDelete = 'device_delete',
  DeviceById = 'device_by_id',
  DeviceVehiclesImportData = 'devices_vehicles_import_data',
  DeviceMoveDevices = 'move_device',
  DeviceNotesHistory = 'device_notes_history',
  DeviceInstallUninstall = 'device_install_uninstall',
  DeviceEditStatus = 'devices_edit_status',
  DeviceEditDevice = 'devices_edit_device',
  DeviceEditVehicle = 'devices_edit_vehicle',
  DeviceEditRawDataLog = 'devices_edit_raw_data_log',
  DeviceSensorList = 'device_sensor_list',
  DeviceSensorEdit = 'device_sensor_edit',
  DeviceSensorView = 'device_sensor_view',
  DeviceSensorCreate = 'device_sensor_create',
  DeviceSensorDelete = 'device_sensor_delete',

  ReportsSection = 'reports_section',
  ReportsRoutes = 'reports_routes',
  ReportsGeofences = 'reports_geofences',
  ReportsSensors = 'reports_sensors',
  ReportsFuel = 'reports_fuel',
  ReportsDriverBehaviour = 'reports_driver_behaviour',
  ReportsMaintenance = 'reports_maintenance',
  ReportsSummary = 'reports_summary',

  FleetSection = 'fleet_section',
  FleetSectionDashboard = 'fleet_section_dashboard',
  FleetSectionFleet = 'fleet_section_fleet',
  FleetSectionServiceReminders = 'fleet_section_service_reminders',
  FleetSectionDocuments = 'fleet_section_documents',
  FleetSectionEditStatus = 'fleet_section_edit_status',
  FleetSectionEditGeneral = 'fleet_section_edit_general',
  FleetSectionEditSpecification = 'fleet_section_edit_specification',
  FleetSectionEditDocuments = 'fleet_section_edit_documents',
  FleetSectionEditServiceReminder = 'fleet_section_edit_service_reminder',
  FleetSectionRepairCosts = 'fleet_section_edit_repair_costs',
  FleetSectionAddVehicle = 'fleet_section_add_vehicle',
  FleetSectionCheckVehicle = 'fleet_section_check_vehicle',

  RepairCostList = 'repair_cost_list',
  RepairCostNew = 'repair_cost_new',
  RepairCostEdit = 'repair_cost_edit',
  RepairCostDelete = 'repair_cost_delete',

  ServiceRecordList = 'service_record_list',
  ServiceRecordNew = 'service_record_new',
  ServiceRecordEdit = 'service_record_edit',
  ServiceRecordDelete = 'service_record_delete',

  ReminderList = 'reminder_list',
  ReminderNew = 'reminder_new',
  ReminderEdit = 'reminder_edit',
  ReminderDelete = 'reminder_delete',

  DocumentList = 'document_list',
  DocumentNew = 'document_new',
  DocumentEdit = 'document_edit',
  DocumentDelete = 'document_delete',

  VehicleNew = 'vehicle_new',
  VehicleList = 'vehicle_list',
  VehicleDelete = 'vehicle_delete',
  VehicleEdit = 'vehicle_edit',
  VehicleGroupList = 'vehicle_group_list',
  VehicleGroupNew = 'vehicle_group_new',
  VehicleGroupEdit = 'vehicle_group_edit',
  VehicleGroupDelete = 'vehicle_group_delete',
  VehicleNotesHistory = 'vehicle_notes_history',
  VehicleInspectionPlanList = 'vehicle_inspection_plan_list',
  VehicleInspectionPlanCreate = 'vehicle_inspection_plan_create',
  VehicleInspectionPlanEdit = 'vehicle_inspection_plan_edit',

  DepotList = 'depot_list',
  DepotNew = 'depot_new',
  DepotEdit = 'depot_edit',
  DepotDelete = 'depot_delete',

  AreaList = 'area_list',
  AreaNew = 'area_new',
  AreaEdit = 'area_edit',
  AreaDelete = 'area_delete',
  AreaGroupList = 'area_group_list',
  AreaGroupNew = 'area_group_new',
  AreaGroupEdit = 'area_group_edit',
  AreaGroupDelete = 'area_group_delete',

  FuelSection = 'fuel_section',
  FuelSummary = 'fuel_summary',
  FuelRecords = 'fuel_records',
  FuelImportData = 'fuel_import_data',
  FuelTypesList = 'fuel_types_list',

  ConfigurationSection = 'configuration_section',
  ConfigurationGeofences = 'configuration_geofences',
  ConfigurationCompanyInfo = 'configuration_company_info',
  ConfigurationDrivingOptions = 'configuration_driving_options',
  ConfigurationTemplates = 'configuration_templates',
  ConfigurationFleet = 'configuration_fleet',
  ConfigurationNotifications = 'configuration_notifications',
  ConfigurationUsers = 'configuration_users',
  ConfigurationUserGroups = 'configuration_user_groups',

  UserGroupList = 'user_group_list',
  UserGroupNew = 'user_group_new',
  UserGroupEdit = 'user_group_edit',
  UserGroupDelete = 'user_group_delete',

  AlertsSection = 'alerts_section',
  SupportSection = 'support_section',

  InspectionFormFill = 'inspection_form_fill',
  InspectionFormFilled = 'inspection_form_filled',

  ReportsSensorsIo = 'reports_sensors_io',
  DeviceSensorIoTypesList = 'device_sensor_io_types_list',

  ScheduledReportList = 'scheduled_report_list',
  ScheduledReportView = 'scheduled_report_view',
  ScheduledReportCREATE = 'scheduled_report_create',
  ScheduledReportEDIT = 'scheduled_report_edit',
  ScheduledReportDELETE = 'scheduled_report_delete',

  ResellerSection = 'reseller_section',
  LoginAsReseller = 'login_as_reseller',
  ResellerUserList = 'reseller_user_list',
  ResellerUserDelete = 'reseller_user_delete',
  ResellerUserEdit = 'reseller_user_edit',
  ResellerUserNew = 'reseller_user_new',
  ResellerList = 'reseller_list',
  ResellerNew = 'reseller_new',
  ResellerEdit = 'reseller_edit',
  ResellerDelete = 'reseller_delete',
  ResellerNotesHistory = 'reseller_notes_history',
  ResellerTeamSection = 'reseller_team_section',
}
